/** Back and Forward through the app (2026-10-05), as in Teams: the app's
 *  own history (react-router's, which keeps an index in history.state).
 *  How far Forward can go is remembered for the session: a new page after
 *  going back drops what was ahead, as a browser does. */
import { useEffect, useState } from "react";
import { useLocation, useNavigate, useNavigationType } from "react-router-dom";

const MAX_KEY = "wov.nav.maxIdx";

function idxNow(): number {
  const st = window.history.state as { idx?: number } | null;
  return typeof st?.idx === "number" ? st.idx : 0;
}
function readMax(): number {
  try {
    return Number(sessionStorage.getItem(MAX_KEY) ?? "0") || 0;
  } catch {
    return 0;
  }
}
function writeMax(v: number): void {
  try {
    sessionStorage.setItem(MAX_KEY, String(v));
  } catch {
    /* this page only */
  }
}

export function useHistoryNav(): { canBack: boolean; canForward: boolean; back: () => void; forward: () => void } {
  const location = useLocation();
  const type = useNavigationType();
  const navigate = useNavigate();
  const [state, setState] = useState(() => ({ idx: idxNow(), max: Math.max(readMax(), idxNow()) }));
  useEffect(() => {
    const idx = idxNow();
    let max = readMax();
    if (type === "PUSH") max = idx; // a new page: nothing ahead any more
    else max = Math.max(max, idx);
    writeMax(max);
    setState({ idx, max });
  }, [location.key, type]);
  return {
    canBack: state.idx > 0,
    canForward: state.idx < state.max,
    back: () => navigate(-1),
    forward: () => navigate(1),
  };
}
